import { useEffect, useState } from 'react';

export const useNavigationHistory = () => {
  const [previousPath, setPreviousPath] = useState(null);
  const [currentPath, setCurrentPath] = useState(null);
  const [isDirectLink, setIsDirectLink] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const prev = sessionStorage.getItem('previousPath');
      const current = sessionStorage.getItem('currentPath');

      setPreviousPath(prev);
      setCurrentPath(current);
      setIsDirectLink(prev === current || !prev);
    }
  }, []);

  return { previousPath, currentPath, isDirectLink };
};
